import { Component } from 'react';

export class SidebarPersistentHeader extends Component {
  render() {
    return this.props.children;
  }
}
